import { observable, action, makeObservable } from "mobx";
import { startAbTest, sendUserParamsToMetrics } from "../utils/sendMetric";

class AbTest {
  /** Вариант хедера (null, 'statistika_rynka', 'servisy_dlya_analitiki', 'dinamika_rynka', 'rynok_v_cifrah') */
  analyticsHeaderVariant = null;

  constructor(rootStore) {
    makeObservable(this, {
      analyticsHeaderVariant: observable,
      setAnalyticsHeaderVariant: action,
    });

    this.rootStore = rootStore;
    
    startAbTest({
      // Обработчик для теста хедера
      header_analytics: (values) => {
        const currentVariant = values && values.length > 0 ? values[0] : null;
        this.setAnalyticsHeaderVariant(currentVariant);
        sendUserParamsToMetrics({
          "ab-header-analytics": currentVariant,
        });
      }
    });
  }

  setAnalyticsHeaderVariant = (variant) => {
    this.analyticsHeaderVariant = variant;
  };

  isAnalyticsHeaderVariant = (variant) => this.analyticsHeaderVariant === variant;
}

export default AbTest;